import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

export const GetAll = createAsyncThunk(
    "masters/contact_us_centres/get-all",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${APIS.Masters.ContactUsCentres}?term=${filter?.name || ""}&contact_us_centre_type_id=${filter?.contact_us_centre_type_id || ""
                }&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE
                }`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// GetSingle a specific contact_us_centres
export const GetSingle = createAsyncThunk(
    "masters/contact_us_centres/get",
    async (id, { rejectWithValue }) => {
        try {
            const res = await GET(`${APIS.Masters.ContactUsCentres}/${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Create a new contact_us_centres
export const Create = createAsyncThunk(
    "masters/contact_us_centres/create",
    async (data, { rejectWithValue }) => {
        try {
            const res = await POST(APIS.Masters.ContactUsCentres, data);
            if (res?.success) {
                return res;
            }
            return rejectWithValue(res);
        } catch (error) {
            console.log(error, "error state");
            return rejectWithValue(error);
        }
    }
);
// Update a contact_us_centres
export const Update = createAsyncThunk(
    "masters/contact_us_centres/update",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await PUT(`${APIS.Masters.ContactUsCentres}/${id}`, data);
            return res;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
// Delete a contact_us_centres
export const Delete = createAsyncThunk(
    "masters/contact_us_centres/delete",
    async (id, { rejectWithValue }) => {
        try {
            await DELETE(`${APIS.Masters.ContactUsCentres}/${id}`);
            return id;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Change the status of a contact_us_centres
export const Status = createAsyncThunk(
    "masters/contact_us_centres/status",
    async (id, { rejectWithValue }) => {
        try {
            const res = await POST(`${APIS.Masters.ContactUsCentres}/${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const Slice = createSlice({
    name: "contact_us_centres",
    initialState: {
        data: [],
        current_page: IDS.PAGE,
        total_pages: IDS.TOTALPAGES,
        per_page: IDS.PERPAGE,
        total: IDS.TOTAL,
        status: IDS.SLICESTATUS.Idle,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GetAll.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAll.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.data = action.payload?.data?.data || [];
                state.current_page = action.payload?.data?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
                state.total = action.payload?.data?.total || IDS.TOTAL;
            })
            .addCase(GetAll.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            .addCase(GetSingle.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetSingle.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
            })
            .addCase(GetSingle.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            .addCase(Create.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Create.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data.unshift(action.payload.data);
            })
            .addCase(Create.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            .addCase(Update.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Update.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                const index = state.data.findIndex(
                    (contact_us_centres) => contact_us_centres.id === action.payload?.data?.id
                );
                if (index !== -1) {
                    state.data[index] = action.payload.data;
                }
            })
            .addCase(Update.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            .addCase(Delete.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Delete.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = state.data.filter(
                //   (stateItem) => stateItem.id !== action.payload
                // );
                state.data = state.data.filter(
                    (contact_us_centres) => contact_us_centres.id !== action.payload
                );
            })
            .addCase(Delete.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            .addCase(Status.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Status.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                const index = state.data.findIndex(
                    (contact_us_centres) => contact_us_centres.id === action.payload?.id
                );
                if (index !== -1) {
                    state.data[index].status = !state.data[index].status;
                }
            })
            .addCase(Status.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            });
    },
});

export default Slice.reducer;
